import { CollectiveActionType } from "../../containers/centralView/collectiveEditionView/components/types/collectiveActionType";
import { KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, LandslideDevelopment, LandslideWaters } from "../../contexts/krFormContext";
import { ObjectType } from "../../contexts/types/card";
import { setDevelopmentsRelTech } from "../form";
import { CollectivePreviewKey } from "./preview";

export const validate = (objectType: ObjectType, collectiveActions: { [key: string]: CollectiveActionType | null }, krForm: krFormTypes) => {
    if (objectType === ObjectType.KRO) {
        const _kr = krForm as KrLandslideFormTypes;
        if (!isSet(collectiveActions[CollectivePreviewKey.miejscowoscL]) && isSet(_kr.landslideAttributes?.miejscowosC_NAZWA)) return false;
        //if (!isSet(collectiveActions[CollectivePreviewKey.geographicalLands]) && isArraySet(_kr.geographicalLands)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.tectonicUnits]) && isArraySet(_kr.tectonicUnits)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.sytuacjaGeomorfologiczna]) && isSet(_kr.landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.ukladGeologiczny]) && isSet(_kr.landslideAttributes?.uklaD_GEOLOGICZNY_SID)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.rodzajMaterialu]) && isSet(_kr.landslideAttributes?.rodzaJ_MATERIALU_SID)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.rodzajRuchu]) && isSet(_kr.landslideAttributes?.rodzaJ_RUCHU_SID)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.charakterystykaOpis]) && isSet(_kr.landslideAttributes?.charakterystykA_OPIS)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.tectonics]) && isArraySet(_kr.tectonics)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.skaly]) && isArraySet(_kr.rocks)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.koluvia]) && isArraySet(_kr.koluvia)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.waterMainSlope]) && isArraySet(getSelectedWarters(_kr.waters, 2))) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.waterSlopeBelow]) && isArraySet(getSelectedWarters(_kr.waters, 3))) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.waterSlopeOnsides]) && isArraySet(getSelectedWarters(_kr.waters, 4))) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.wiekiGeneza]) && isArraySet(getStartDevelopments(_kr.developments))) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.liniePrzesylowe]) && hasAnyLines(_kr)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.ocenaMozliwosci]) && isSet(_kr.landslideAttributes?.dalszE_RUCHY)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.stanBadan]) && (isArraySet(_kr.publications) || isArraySet(_kr.documents))) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.uwagi]) && isSet(_kr.landslideAttributes?.uwagi)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.ellaborators]) && isArraySet(_kr.elaborators)) return false;
    } else if (objectType === ObjectType.KRTZ) {
        const _kr = krForm as KrEndangeredAreaFormTypes;
        if (!isSet(collectiveActions[CollectivePreviewKey.miejscowoscT]) && isSet(_kr.endangeredAreaAttributes?.miejscowosC_NAZWA)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.ellaborators]) && isArraySet(_kr.elaborators)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.wskazania]) && isSet(_kr.endangeredAreaAttributes?.wskazania)) return false;
        if (!isSet(collectiveActions[CollectivePreviewKey.glowneKryterium]) && isArraySet(_kr.designationCriteria)) return false;
    }
    return true;
}

const getSelectedWarters = (waters?: LandslideWaters[], index?: number) => {
    return waters?.filter((dict) => {
        return dict.tyP_STREFY_SID === index
    });
}

const getStartDevelopments = (developments?: LandslideDevelopment[]) => {
    return developments?.filter((dict) => {
        return dict.tyP_ZDARZENIA_SID === 1;
    })
}

const hasAnyLines = (krForm: KrLandslideFormTypes) => {
    if (krForm.landslideAttributes?.liniE_ENERGETYCZNE) return true;
    if (krForm.landslideAttributes?.liniE_TELEFONICZNE) return true;
    if (krForm.landslideAttributes?.liniE_WODOCIAGI) return true;
    if (krForm.landslideAttributes?.liniE_KANALIZACJA) return true;
    if (krForm.landslideAttributes?.liniE_GAZOCIAGI) return true;
    if (krForm.landslideAttributes?.liniE_INNE) return true;
    return false;
}

export const toSave = (objectType: ObjectType, collectiveActions: { [key: string]: CollectiveActionType | null }, krForm: krFormTypes, forms: any[]) => {
    if (objectType === ObjectType.KRO) {
        return toLandslideSave(collectiveActions, krForm, forms);
    }
    return toEndangeredAreaSave(collectiveActions, krForm, forms);
}

const toLandslideSave = (collectiveActions: { [key: string]: CollectiveActionType | null }, krForm: krFormTypes, forms: any[]) => {
    return forms.map((f: any) => {
        return toLandslide(collectiveActions, krForm, f);
    });
}

const toEndangeredAreaSave = (collectiveActions: { [key: string]: CollectiveActionType | null }, krForm: krFormTypes, forms: any[]) => {
    return forms.map((f: any) => {
        return toEndangeredArea(collectiveActions, krForm, f);
    });
}

const isSet = (value: any) => {
    return value !== null && value !== undefined && value !== '';

}

const isArraySet = (value: any) => {
    return isSet(value) && value.length > 0;
}

const toLandslide = (collectiveActions: { [key: string]: CollectiveActionType | null }, _krForm: KrLandslideFormTypes, form: any) => {
    var cf = structuredClone(form) as KrLandslideFormTypes;
    var krForm = structuredClone(_krForm) as KrLandslideFormTypes;

    var osuwiskoGid = cf.landslideAttributes?.globalid;
    krForm.waters?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.tectonics?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.rocks?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    //krForm.rockDeposits?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    //krForm.rocksDepositAzimuths?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.tectonicUnits?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    //krForm.geographicalLands?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.developments?.forEach(el => {
        el.osuwiskO_GID = osuwiskoGid;
        if (el.epoka !== null && el.epoka !== undefined) {
            el.epoka = el.epoka?.toString();
        }
    });
    krForm.koluvia?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.documents?.forEach(el => { el.osuwiskO_GID = osuwiskoGid });
    krForm.publications?.forEach(el => { el.osuwiskA_GID = osuwiskoGid });

    if (cf.landslideAttributes !== undefined) {
        if (isSet(collectiveActions[CollectivePreviewKey.miejscowoscL])) {
            cf.landslideAttributes.miejscowosC_NAZWA = krForm.landslideAttributes?.miejscowosC_NAZWA;
            cf.landslideAttributes.miejscowosC_GID = krForm.landslideAttributes?.miejscowosC_GID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.sytuacjaGeomorfologiczna])) {
            cf.landslideAttributes.sytuacjA_GEOMORFOLOGICZNA_SID = krForm.landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.ukladGeologiczny])) {
            cf.landslideAttributes.uklaD_GEOLOGICZNY_SID = krForm.landslideAttributes?.uklaD_GEOLOGICZNY_SID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.rodzajMaterialu])) {
            cf.landslideAttributes.rodzaJ_MATERIALU_SID = krForm.landslideAttributes?.rodzaJ_MATERIALU_SID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.rodzajRuchu])) {
            cf.landslideAttributes.rodzaJ_RUCHU_SID = krForm.landslideAttributes?.rodzaJ_RUCHU_SID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.charakterystykaOpis])) {
            if (krForm.landslideAttributes?.charakterystykA_OPIS) {
                const characteristycType = collectiveActions[CollectivePreviewKey.charakterystykaOpis];
                if (characteristycType === CollectiveActionType.Overwrite) {
                    cf.landslideAttributes.charakterystykA_OPIS = krForm.landslideAttributes?.charakterystykA_OPIS;
                } else if (characteristycType === CollectiveActionType.Add) {
                    cf.landslideAttributes.charakterystykA_OPIS = cf.landslideAttributes.charakterystykA_OPIS
                        ? `${cf.landslideAttributes.charakterystykA_OPIS} ${krForm.landslideAttributes?.charakterystykA_OPIS}`
                        : krForm.landslideAttributes?.charakterystykA_OPIS;
                } else {
                    cf.landslideAttributes.charakterystykA_OPIS = '';
                }
            }
        }
        if (isSet(collectiveActions[CollectivePreviewKey.liniePrzesylowe])) {
            cf.landslideAttributes.liniE_ENERGETYCZNE = krForm.landslideAttributes?.liniE_ENERGETYCZNE;
            cf.landslideAttributes.liniE_TELEFONICZNE = krForm.landslideAttributes?.liniE_TELEFONICZNE;
            cf.landslideAttributes.liniE_WODOCIAGI = krForm.landslideAttributes?.liniE_WODOCIAGI;
            cf.landslideAttributes.liniE_KANALIZACJA = krForm.landslideAttributes?.liniE_KANALIZACJA;
            cf.landslideAttributes.liniE_GAZOCIAGI = krForm.landslideAttributes?.liniE_GAZOCIAGI;
            cf.landslideAttributes.liniE_INNE = krForm.landslideAttributes?.liniE_INNE;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.ocenaMozliwosci])) {
            cf.landslideAttributes.dalszE_RUCHY = krForm.landslideAttributes?.dalszE_RUCHY;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.uwagi])) {
            const uwagiType = collectiveActions[CollectivePreviewKey.uwagi];
            if (uwagiType === CollectiveActionType.Overwrite) {
                cf.landslideAttributes.uwagi = krForm.landslideAttributes?.uwagi;
            } else if (uwagiType === CollectiveActionType.Add) {
                cf.landslideAttributes.uwagi = cf.landslideAttributes.uwagi
                    ? `${cf.landslideAttributes.uwagi} ${krForm.landslideAttributes?.uwagi}`
                    : krForm.landslideAttributes?.uwagi;
            } else {
                cf.landslideAttributes.uwagi = '';
            }
        }
    }
    //toArraySave(collectiveActions[CollectivePreviewKey.geographicalLands], krForm, cf, "geographicalLands", "nazwa");
    toArraySave(collectiveActions[CollectivePreviewKey.tectonicUnits], krForm, cf, "tectonicUnits", "jednostkA_TEKTONICZNA_GID");
    toSkalySave(collectiveActions[CollectivePreviewKey.skaly], krForm, cf);
    toArraySave(collectiveActions[CollectivePreviewKey.tectonics], krForm, cf, "tectonics", "rodzaJ_TEKTONIKI_SID");
    toArraySave(collectiveActions[CollectivePreviewKey.koluvia], krForm, cf, "koluvia", "rodzaJ_KOLUWIUM_SID", true);
    toWaterSave(collectiveActions[CollectivePreviewKey.waterMainSlope], krForm, cf, 2);
    toWaterSave(collectiveActions[CollectivePreviewKey.waterSlopeBelow], krForm, cf, 3);
    toWaterSave(collectiveActions[CollectivePreviewKey.waterSlopeOnsides], krForm, cf, 4);
    toWiekiGenezaSave(collectiveActions[CollectivePreviewKey.wiekiGeneza], krForm, cf);
    toStanBadanSave(collectiveActions[CollectivePreviewKey.stanBadan], krForm, cf);
    toElaboratorsSave(collectiveActions[CollectivePreviewKey.ellaborators], krForm, cf);

    return cf;
}

const toEndangeredArea = (collectiveActions: { [key: string]: CollectiveActionType | null }, _krForm: KrEndangeredAreaFormTypes, form: any) => {
    var cf = structuredClone(form) as KrEndangeredAreaFormTypes;
    var krForm = structuredClone(_krForm) as KrEndangeredAreaFormTypes;

    var terenGid = cf.endangeredAreaAttributes?.globalid;
    krForm.designationCriteria?.forEach(el => { el.tereN_ZAGROZONY_GID = terenGid });

    if (cf.endangeredAreaAttributes !== undefined) {
        if (isSet(collectiveActions[CollectivePreviewKey.miejscowoscT])) {
            cf.endangeredAreaAttributes.miejscowosC_NAZWA = krForm.endangeredAreaAttributes?.miejscowosC_NAZWA;
            cf.endangeredAreaAttributes.miejscowosC_GID = krForm.endangeredAreaAttributes?.miejscowosC_GID;
        }
        if (isSet(collectiveActions[CollectivePreviewKey.wskazania])) {
            cf.endangeredAreaAttributes.wskazania = krForm.endangeredAreaAttributes?.wskazania;
        }
    }
    toCriterionSave(collectiveActions[CollectivePreviewKey.glowneKryterium], krForm, cf);
    toElaboratorsSave(collectiveActions[CollectivePreviewKey.ellaborators], krForm, cf);

    return cf;
}

const toStanBadanSave = (collectiveType: CollectiveActionType | null, krForm: any, form: any) => {
    const comaprePFunc = (f: any, k: any) => {
        return f.details?.roK_POWSTANIA === k.details?.roK_POWSTANIA && f.details?.autorzy === k.details?.autorzy &&
            f.details?.publikacjA_SOPO === k.details?.publikacjA_SOPO && f.details?.autorzy === k.details?.autorzy;
    };
    toPartArraySave(collectiveType, krForm, form, "publications", '', null, comaprePFunc);
    const comapreDFunc = (f: any, k: any) => {
        return f.rok === k.rok && f.autorzy === k.autorzy && f.tytul === k.tytul;
    };
    toPartArraySave(collectiveType, krForm, form, "documents", '', null, comapreDFunc);
}

const toCriterionSave = (collectiveType: CollectiveActionType | null, krForm: any, form: any) => {
    if (collectiveType === CollectiveActionType.Delete) {
        form.designationCriteria = [];
    } else {
        const comapreFunc = (f: any, k: any) => {
            return f.kryT_WYZN_TZ_GLOWNE_ID === k.kryT_WYZN_TZ_GLOWNE_ID // && f.uzasadnienie === k.uzasadnienie
        };
        (krForm as KrEndangeredAreaFormTypes).designationCriteria?.forEach(desCrit => {
            const filterValue = desCrit.kryT_WYZN_TZ_GLOWNE_ID;
            toPartArraySave(collectiveType, krForm, form, "designationCriteria", "kryT_WYZN_TZ_GLOWNE_ID", filterValue, comapreFunc);
        })
    }
}

const toWaterSave = (collectiveType: CollectiveActionType | null, krForm: any, form: any, filterValue: number) => {
    const comapreFunc = (f: any, k: any) => {
        return f.tyP_PRZEJAWU_SID === k.tyP_PRZEJAWU_SID
    };
    toPartArraySave(collectiveType, krForm, form, "waters", "tyP_STREFY_SID", filterValue, comapreFunc);
}

const toWiekiGenezaSave = (collectiveType: CollectiveActionType | null, krForm: KrLandslideFormTypes, form: KrLandslideFormTypes) => {
    // Return if add action and 'powstanie' already exists for form
    const startDevelopments = form?.developments?.filter((d: any) => d.tyP_ZDARZENIA_SID === 1);
    if (!isSet(collectiveType) || (collectiveType === CollectiveActionType.Add && isArraySet(startDevelopments))) {
        setDevelopmentsRelTech(form);
        return;
    }

    // Prepare save
    if (collectiveType === CollectiveActionType.Delete) {
        filterPowstanie(form);
        setDevelopmentsRelTech(form);
    } else if (krForm?.developments && krForm?.developments.length === 1) {
        if (collectiveType === CollectiveActionType.Overwrite) {
            filterPowstanie(form);
        }
        setDevelopmentsRelTech(form);
        const kolejnosc = form?.developments ? form.developments.length : 0;
        const newRec = krForm.developments[0];
        newRec.kolejnosc = kolejnosc;
        const newCauses = krForm?.movementCause ? krForm.movementCause
            .map(m => { return { ...m, idx: kolejnosc } }) : [];

        if (collectiveType === CollectiveActionType.Add || collectiveType === CollectiveActionType.Overwrite) {
            form.developments = joinData(form.developments, [newRec]);
            form.movementCause = joinData(form.movementCause, newCauses);
        }
    } else {
        setDevelopmentsRelTech(form);
    }
}

const filterPowstanie = (form: KrLandslideFormTypes) => {
    const powstanieGids = form.developments?.filter(d => d.tyP_ZDARZENIA_SID === 1)?.map(d => d.globalid);
    if (form.developments && form.movementCause) {
        form.movementCause = form.movementCause.filter(c => {
            return !(powstanieGids?.includes(c.osuwiskO_ROZWOJ_GID));
        });
    }
    if (form.developments) {
        form.developments = form.developments.filter(d => d.tyP_ZDARZENIA_SID !== 1);
    }
}

const joinData = (arry?: any[], values?: any[]) => {
    const isNewSet = isArraySet(values);
    const isOldSet = isArraySet(arry);
    if (isOldSet && isNewSet) {
        return [...arry!, ...values!];
    } else if (isNewSet) {
        return values;
    } else if (isOldSet) {
        return arry;
    }
    return [];
}

//Save all for "Add" collective action type
const toSkalySave = (collectiveType: CollectiveActionType | null, krForm: any, form: any) => {
    const comapreRFunc = (f: any, k: any) => {
        return false;
        /*
        const fstaryOd = f.stratygrafiA_OD_SID === undefined ? null : f.stratygrafiA_OD_SID;
        const fstaryDo = f.stratygrafiA_DO_SID === undefined ? null : f.stratygrafiA_DO_SID;
        const kstaryOd = k.stratygrafiA_OD_SID === undefined ? null : k.stratygrafiA_OD_SID;
        const kstaryDo = k.stratygrafiA_DO_SID === undefined ? null : k.stratygrafiA_DO_SID;
        return f.skalY_RODZAJ_SID === k.skalY_RODZAJ_SID && fstaryOd === kstaryOd && fstaryDo === kstaryDo
        */
    };
    let startIndex = form?.rocks.length;

    const rockIdx = toPartArraySave(collectiveType, krForm, form, "rocks", '', null, comapreRFunc, false, startIndex);
    const comapreRCFunc = (f: any, k: any) => {
        return false;
        //return f.rodzaJ_ZALEGANIA_SKALY_SID === k.rodzaJ_ZALEGANIA_SKALY_SID && f.osuwiskO_SKALA_GID === k.osuwiskO_SKALA_GID;
    };
    const rockDepIdx = toPartArraySave(collectiveType, krForm, form, "rockDeposits", '', null, comapreRCFunc, true, rockIdx);
    const comapreRCAFunc = (f: any, k: any) => {
        return false;
        //return f.zaleganiE_SKALY_OSUWISKA_GID === k.zaleganiE_SKALY_OSUWISKA_GID && f.azymut === k.azymut && f.upad === k.upad
    };
    toPartArraySave(collectiveType, krForm, form, "rocksDepositAzimuths", '', null, comapreRCAFunc, true, rockDepIdx);
}

//comaperFunc, if return true, prevent add item for "Add" collective action
const toPartArraySave = (collectiveType: CollectiveActionType | null, krForm: any, form: any, arrayName: string, attributeName: string, filterValue: number | null, comaperFunc: Function, hasIdx: boolean = false, startIndex?: number) => {
    let _startIdx = null;
    if (isSet(collectiveType)) {
        const fcf = filterValue !== null ? form[arrayName] ? form[arrayName].filter((f: any) => {
            return f[attributeName] === filterValue;
        }) : [] : form[arrayName];

        let kr = filterValue !== null ? krForm[arrayName] ? krForm[arrayName].filter((f: any) => {
            return f[attributeName] === filterValue;
        }) : [] : krForm[arrayName];

        if (collectiveType === CollectiveActionType.Add) {
            kr?.forEach((k: any) => {
                const existing = fcf?.some((f: any) => comaperFunc(f, k));
                if (!existing) {
                    if (hasIdx && startIndex !== undefined && startIndex !== null) { k.idx = k.idx + startIndex; }
                    if (arrayName === "rocks") { k.kolejnosc = k.kolejnosc + startIndex; }
                    if (form[arrayName] !== undefined && form[arrayName] !== null) {
                        form[arrayName].push(k);
                    } else {
                        form[arrayName] = [k];
                    }
                }
            });
            _startIdx = startIndex;
        } else if (collectiveType === CollectiveActionType.Overwrite) {
            let itemsToSave = filterValue !== null ? form[arrayName] ? form[arrayName].filter((f: any) => {
                return f[attributeName] !== filterValue;
            }) : [] : [];

            _startIdx = itemsToSave.length;
            if (hasIdx && startIndex !== undefined && startIndex !== null) {
                kr?.forEach((w: any) => {
                    w.idx = w.idx + startIndex;
                    itemsToSave.push(w);
                })
            } else {
                kr?.forEach((w: any) => {
                    itemsToSave.push(w);
                })
            }
            form[arrayName] = itemsToSave;
        } else if (collectiveType === CollectiveActionType.Delete) {
            let items = filterValue !== null ? form[arrayName] ? form[arrayName].filter((f: any) => {
                return f[attributeName] !== filterValue;
            }) : [] : [];

            form[arrayName] = items === undefined || items === null ? [] : items;
            _startIdx = 0;
        }
    }
    return _startIdx;
}

const toElaboratorsSave = (collectiveType: CollectiveActionType | null, krForm: any, form: any) => {
    if (isSet(collectiveType)) {
        if (collectiveType === CollectiveActionType.Add) {
            krForm.elaborators?.forEach((k: any) => {
                const existing = form.elaborators?.some((f: any) => f.imie === k.imie && f.nazwisko === k.nazwisko && f.uprawnienia === k.uprawnienia &&
                    f.firmA_NAZWA === k.firmA_NAZWA && f.firmA_MIEJSCOWOSC === k.firmA_MIEJSCOWOSC);
                if (!existing) {
                    if (form.elaborators !== undefined && form.elaborators !== null) {
                        k.kolejnosc = form.elaborators.length + 1;
                        form.elaborators.push(k);
                    } else {
                        k.kolejnosc = 1;
                        form.elaborators = [k];
                    }
                }
            });
        } else {
            form.elaborators = krForm.elaborators === undefined || krForm.elaborators === null ? [] : krForm.elaborators;
        }
    }
}

const toArraySave = (collectiveType: CollectiveActionType | null, krForm: any, form: any, arrayName: string, attributeName: string, kolejnosc?: boolean) => {
    if (isSet(collectiveType)) {
        if (collectiveType === CollectiveActionType.Add) {
            krForm[arrayName]?.forEach((k: any) => {
                const existing = form[arrayName]?.some((f: any) => f[attributeName] === k[attributeName]);
                if (!existing) {
                    if (form[arrayName] !== undefined) {
                        if (kolejnosc) {
                            k.kolejnosc = form.elaborators ? form.elaborators.length + 1 : 1;
                        }
                        form[arrayName].push(k);
                    } else {
                        if (kolejnosc) {
                            k.kolejnosc = 1;
                        }
                        form[arrayName] = [k];
                    }
                }
            });
        } else {
            form[arrayName] = krForm[arrayName] === undefined || krForm[arrayName] === null ? [] : krForm[arrayName];
        }
    }
}
